export default __webpack_public_path__ + "static/group-dont-dark-e5de31bee0f9ad4eb9b26f5561cb8a9a.png";